import { combineEpics } from 'redux-observable';
import { failureOnboardingEnquiriesEpic } from '@bridebook/web/lib/onboarding/epics/send-enquiry-failure-analytics-event-epic';
import { sendEnquirySuccessfulAnalyticsEventEpic } from '@bridebook/web/lib/onboarding/epics/send-enquiry-successful-analytics-event-epic';
import { sendEnquirySuccessfulEpic } from '@bridebook/web/lib/onboarding/epics/send-enquiry-successful-epic';
import { sendLoadedSearchResultsAnalyticsEvent } from '@bridebook/web/lib/onboarding/epics/send-loaded-search-results-analytics-event';
import { sendOnboardingEnquiriesEpic } from '@bridebook/web/lib/onboarding/epics/send-onboarding-enquiries-epic';
import { sendStartOnboardingAnalyticsEventEpic } from '@bridebook/web/lib/onboarding/epics/send-start-onboarding-analytics-event-epic';

export const onboardingEpics = combineEpics(
  sendStartOnboardingAnalyticsEventEpic,
  sendOnboardingEnquiriesEpic,
  sendEnquirySuccessfulAnalyticsEventEpic,
  failureOnboardingEnquiriesEpic,
  sendEnquirySuccessfulEpic,
  sendLoadedSearchResultsAnalyticsEvent,
);
